<template>
  <d-container fluid class="main-content-container px-0">
    <div v-if="isEditMode && !loadedOrderData">
      {{ $t('ui.dataLoading') }}&hellip;
    </div>

    <template v-if="userIsWarehouseman">
      <order-collect
        v-if="loadedOrderData && !isWarehousePreview"
        :order-data="orderData" />

      <order-view
        v-if="loadedOrderData && isWarehousePreview"
        :isLocked="true"
        :order-data="orderData" />
    </template>

    <template v-else-if="userIsAdminOrWorker">
      <template v-if="!isEditMode">
        <order :isLoading="formSubmitInProgress" />
      </template>

      <template v-else-if="isBlocked || isLocked">
        <order-view
          v-if="loadedOrderData"
          :isLocked="isLocked"
          :order-data="orderData" />
      </template>

      <template v-else>
        <order
          v-if="loadedOrderData"
          ref="orderComponent"
          :isLocked="isLocked"
          :isLoading="formSubmitInProgress"
          :order-data="orderData" />
      </template>
    </template>

    <d-alert
      v-if="loadError"
      show
      theme="warning">
      {{ $t('ui.dataLoadingFailed') }} <a href="javascript:window.location.reload();" class="alert-link">{{ $t('ui.refreshPage') }}</a> {{ $t('ui.toTryAgain') }}
    </d-alert>
  </d-container>
</template>

<script>
import FormUtils from './../../utils/FormUtils.js';
import Order from './Order.vue';
import OrderCollect from './OrderCollect.vue';
import OrderView from './OrderView.vue';
import Vue from 'vue';

export default {
  name: 'order-wrapper',
  components: {
    'order': Order,
    'order-collect': OrderCollect,
    'order-view': OrderView
  },
  computed: {
    isEditMode () {
      return !!this.$route.params.id;
    },
    isLocked () {
      return this.orderData && !this.orderData.can_update;
    },
    userIsWarehouseman () {
      return this.$store.getters.getUserType === 'warehouse_manager';
    },
    userIsAdminOrWorker () {
      return this.$store.getters.getUserType === 'admin' || this.$store.getters.getUserType === 'worker';
    },
    isWarehousePreview () {
      return this.$route.path.indexOf('/zamowienia-wszystkie/podglad/') > -1;
    },
    isOrderEditMode () {
      return this.$route.path.indexOf('/zamowienia/edycja') > -1;
    },
    isIndentList () {
      return this.$route.path.indexOf('/zamowienia-indent') > -1;
    },
    isIndentOfferList () {
      return this.$route.path.indexOf('/oferty-indent') > -1;
    },
    isOfferList () {
      return this.$route.path.indexOf('/oferty/') > -1;
    },
    isOrderList () {
      return this.$route.path.indexOf('/zamowienia/edycja') > -1 || this.$route.path.indexOf('/zamowienia-wszystkie/podglad') > -1 || this.$route.path.indexOf('/zamowienia-hafciarnia/edycja') > -1;
    },
    isBlocked () {
      return this.orderData && !!this.orderData.editing_by && this.orderData.editing_by !== this.$store.state.user.id;
    }
  },
  data () {
    return {
      orderData: null,
      status: '',
      loadedOrderData: false,
      loadError: false,
      view: 'loading',
      formSubmitInProgress: false,
      saveButtonClicked: false,
      backButtonClicked: false,
      toIndentRedirect: false,
      toIndentOfferRedirect: false,
      toNormalOfferRedirect: false,
      toNormalOrderRedirect: false
    };
  },
  mounted () {
    if (this.isEditMode) {
      let previousRoute = sessionStorage.getItem('headwear-crm-previous-view');
      let comesFromNewOrder = previousRoute === '/zamowienia/nowe/' ||
        previousRoute === '/zamowienia-indent/nowe/' ||
        previousRoute === '/oferty/nowa' ||
        previousRoute === '/oferty-indent/nowa';
      this.loadOrderData(!comesFromNewOrder);
      this.$bus.$emit('settlements-reload-needed');
      this.$bus.$on('order-wrapper-reload', this.reload);
    }

    this.$bus.$on('order-form-submit-in-progress', this.changeFormLoadingStatus);
    this.$bus.$on('order-form-back-button-clicked', this.onBackButtonClicked);
    this.$bus.$on('order-form-save-button-clicked', this.onSaveButtonClicked);
    this.$bus.$on('order-form-collect-reload-boxes-accepted-status', this.loadOrderBoxesStatus);
  },
  methods: {
    reload () {
      this.loadedOrderData = false;
      this.loadError = false;
      this.loadOrderData(false);
      this.$bus.$emit('settlements-reload-needed');
    },
    loadOrderData (isInitialLoad = false) {
      FormUtils.loadItemData(this, {
        endpointBase: '/orders/item/',
        instanceFields: [],
        method: 'get',
        loadedKey: 'loadedOrderData',
        errorKey: 'loadError',
        params: {
          with: [
            'attachedServices',
            'ieFiles',
            'files',
            'statuses',
            'orderProducts',
            'orderProducts.orderServices',
            'orderProducts.orderServices.samples',
            'orderProducts.containers',
            'orderProducts.purchaseProduct',
            'orderServices',
            'orderServices.samples',
            'offerProducts',
            'offerServicesGroups',
            'customer',
            'settlements',
            'connected',
            'emails',
            'embrioderyLogs',
            'embroideryReturns',
            'orderProducts.orderServices.sampleImages',
            'orderServices.sampleImages',
            'deliveryNoteConfirmedBy',
            'allOrderPackages',
            'orderPackages',
            'orderProducts.orderPackages',
            'orderServices.orderPackage'
          ]
        },
        successAction: (response) => {
          if (!response) {
            Vue.swal({
              title: this.$t('order.orderNotExistsTitle'),
              text: this.$t('order.orderNotExistsDesc'),
              type: 'warning',
              confirmButtonText: this.$t('ui.ok'),
              buttonsStyling: true
            }).then(() => {
              if (this.isIndentList) {
                this.$router.push('/zamowienia-indent/');
              } else if (this.isIndentOfferList) {
                this.$router.push('/oferty-indent/');
              } else if (this.isOfferList) {
                this.$router.push('/oferty/');
              } else {
                this.$router.push('/zamowienia/');
              }
            });

            return;
          }

          if (response.is_special_requirement && isInitialLoad && response.status !== 'ENDED' && this.userIsAdminOrWorker) {
            Vue.swal({
              title: this.$t('order.hasSpecialRequirementsWarningPopupTitle'),
              text: this.$t('order.hasSpecialRequirementsWarningPopupDesc'),
              type: 'warning',
              confirmButtonText: this.$t('ui.ok'),
              buttonsStyling: true
            }).then(() => {});
          }

          this.status = response.status;
          this.orderData = response;
          this.orderData.deadline = response.deadline ? new Date(response.deadline) : null;
          this.orderData.stash_to = response.stash_to ? new Date(response.stash_to) : null;
          this.orderData.realization_date = response.realization_date ? new Date(response.realization_date) : null;
          this.orderData.shipper_date = response.shipper_date ? new Date(response.shipper_date) : null;
          this.orderData.original_shipment_date = response.original_shipment_date ? new Date(response.original_shipment_date) : null;
          this.orderData.customer_order_date = response.customer_order_date ? new Date(response.customer_order_date) : null;
          this.orderData.order_name = (response.order_name).toString().toLocaleUpperCase();
          this.orderData.order_name_notes = (response.order_name_notes).toString().toLocaleUpperCase();
          this.orderData.indent_offer_services_description = response.indent_offer_services_description || '';
          this.orderData.exclude_from_erp_integration = !!response.exclude_from_erp_integration;

          // Check for potential redirects if order type is invalid
          if (this.isEditMode) {
            let isOffer = this.orderData.status === 'SENT_TO_CUSTOMER' || this.orderData.status === 'NEW';
            let isIndent = !!this.orderData.is_indent;

            // Proper locations short-circuit
            if (
              (isIndent && isOffer && this.isIndentOfferList) ||
              (isIndent && !isOffer && this.isIndentList) ||
              (isOffer && !isIndent && this.isOfferList) ||
              (!isIndent && !isOffer && this.isOrderList)
            ) {
              return;
            }

            // Indent offer
            if (isIndent && isOffer && !this.isIndentOfferList) {
              this.toIndentOfferRedirect = true;
              console.log('[REDIRECT] TO INDENT OFFER');
              this.$router.push('/oferty-indent/edycja/' + this.orderData.id);
              return;
            }

            // Indent order
            if (isIndent && !isOffer && !this.isIndentList) {
              this.toIndentRedirect = true;
              console.log('[REDIRECT] TO INDENT ORDER');
              this.$router.push('/zamowienia-indent/edycja/' + this.orderData.id);
              return;
            }

            // Normal offer
            if (isOffer && !isIndent && !this.isOfferList) {
              this.toNormalOfferRedirect = true;
              console.log('[REDIRECT] TO OFFER');
              this.$router.push('/oferty/edycja/' + this.orderData.id);
              return
            }

            // Normal order
            if (!isIndent && !isOffer && !this.isOrderList) {
              this.toNormalOrderRedirect = true;
              console.log('[REDIRECT] TO ORDER');
              this.$router.push('/zamowienia/edycja/' + this.orderData.id);
            }
          }
        }
      });
    },
    loadOrderBoxesStatus () {
      FormUtils.loadItemData(this, {
        endpointBase: '/orders/item/',
        instanceFields: [],
        method: 'get',
        loadedKey: 'loadedOrderData',
        errorKey: 'loadError',
        params: {
          with: [
            'orderProducts'
          ]
        },
        successAction: (response) => {
          if (!response || !this.orderData) {
            return;
          }

          this.orderData.boxes_accepted_at = response.boxes_accepted_at;
        }
      });
    },
    changeFormLoadingStatus (newStatus) {
      this.formSubmitInProgress = newStatus;
    },
    onBackButtonClicked () {
      this.backButtonClicked = true;
    },
    onSaveButtonClicked () {
      this.saveButtonClicked = true;
    },
    forceOrderSave (next) {
      this.$bus.$emit('order-form-save-before-leave', next);
    }
  },
  beforeRouteLeave (to, from, next) {
    if (!this.userIsAdminOrWorker) {
      this.backButtonClicked = false;
      this.saveButtonClicked = false;
      next();
      return;
    }

    if (this.isBlocked || this.isLocked) {
      this.backButtonClicked = false;
      this.saveButtonClicked = false;
      next();
      return;
    }

    if (this.backButtonClicked || this.saveButtonClicked) {
      this.backButtonClicked = false;
      this.saveButtonClicked = false;
      next();
      return;
    }

    if (
      this.toIndentRedirect ||
      this.toNormalOrderRedirect ||
      this.toIndentOfferRedirect ||
      this.toNormalOfferRedirect
    ) {
      this.backButtonClicked = false;
      this.saveButtonClicked = false;
      next();
      return;
    }

    Vue.swal({
      title: this.$t('order.saveChangesBeforeLeaveTitle'),
      text: this.$t('order.saveChangesBeforeLeaveDesc'),
      type: 'question',
      showCancelButton: true,
      confirmButtonText: this.$t('order.yesSave'),
      cancelButtonText: this.$t('order.leaveWithoutSave')
    }).then((result) => {
      this.backButtonClicked = false;
      this.saveButtonClicked = false;

      if (result.value) {
        this.forceOrderSave(next);
      } else {
        next();
      }
    });
  },
  beforeDestroy () {
    this.$bus.$off('order-wrapper-reload', this.reload);
    this.$bus.$off('order-form-submit-in-progress', this.changeFormLoadingStatus);
    this.$bus.$off('order-form-back-button-clicked', this.onBackButtonClicked);
    this.$bus.$off('order-form-save-button-clicked', this.onSaveButtonClicked);
    this.$bus.$off('order-form-collect-reload-boxes-accepted-status', this.loadOrderBoxesStatus);
  }
};
</script>
